export type InvitableHierarchyFilter = {
  level: 'city' | 'department' | 'region' | 'country';
  placeId?: string;
  name?: string;
  countryCode?: string;
};

export class SearchInvitableUsersAction {
  static readonly type = '[Groups] Search Invitable Users';
  constructor(
    public targetId: string,
    public query: string,
    public limit = 20,
    public append = false,
    public location?: { lat: number; lon: number },
    public radiusMeter?: number,
    // Comma separated list: "pending,requested"
    public status?: string,
    public targetType: 'group' | 'event' = 'group',
    public sportIds?: string[],
    public fetchAll = false,
    public searchMode?: 'radius' | 'hierarchy',
    public hierarchy?: InvitableHierarchyFilter,
  ) { }
}

export class InviteUserToGroupAction {
  static readonly type = '[Groups] Invite User To Group';
  constructor(
    public targetId: string,
    public userId: string,
    public targetType: 'group' | 'event' = 'group',
  ) { }
}

export class InviteMultipleUsersToGroupAction {
  static readonly type = '[Groups] Invite Multiple Users To Group';
  constructor(
    public targetId: string,
    public userIds: string[],
    public targetType: 'group' | 'event' = 'group',
  ) { }
}

export class ClearInviteUsersStateAction {
  static readonly type = '[Groups] Clear Invite Users State';
}

export class MarkUserAsInvitedAction {
  static readonly type = '[Groups] Mark User As Invited';
  constructor(public userId: string) { }
}

export class RemovePendingUserAction {
  static readonly type = '[Groups] Remove Pending User';
  constructor(public userId: string) { }
}

export class RemoveInvitableUserAction {
  static readonly type = '[Groups] Remove Invitable User';
  constructor(public userId: string) { }
}

export type InvitableUserStatus = '' | 'pending' | 'joined' | 'requested';

export class UpdateInvitableUserStatusAction {
  static readonly type = '[Groups] Update Invitable User Status';
  constructor(
    public userId: string,
    public status: InvitableUserStatus,
    public messageInvite?: string,
  ) { }
}

export class SetInitialPendingUsersAction {
  static readonly type = '[Groups] Set Initial Pending Users';
constructor(public userIds: string[]) { }
}

